import { render } from "./SupportWordPress.vue?vue&type=template&id=64fa7c1a&scoped=true"
import script from "./SupportWordPress.vue?vue&type=script&lang=js"
export * from "./SupportWordPress.vue?vue&type=script&lang=js"

import "./SupportWordPress.vue?vue&type=style&index=0&id=64fa7c1a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64fa7c1a"]])

export default __exports__